module.exports = __webpack_public_path__ + "media/images/landing/bg/screens-lafluencers/01-e27eb0e378b23656e3a445a81ca630ed.png";